import React from 'react';
import { DowntimeChart } from '../charts';
import { styles } from '../../styles';

interface DowntimeTabProps {
  machineSerialNo?: string;
  lineId?: string; // Line ID for line-level aggregated data
  shifts: string[];
  syncGroup?: string;
}

const DowntimeTab: React.FC<DowntimeTabProps> = ({ machineSerialNo, lineId, shifts, syncGroup }) => (
  <div className={styles.utility.spacing.xl}>
    {/* syncGroup not used for BaseChart components */}
    <div className={styles.card.chart}>
      <DowntimeChart 
        machineSerialNo={machineSerialNo}
        lineId={lineId}
        shifts={shifts}
        // Note: syncGroup not yet implemented for DowntimeChart (uses BaseChart, not BaseStockChart)
        // syncGroup={syncGroup}
      />
      {/* Suppress unused syncGroup warning */}
      {syncGroup && <div style={{ display: 'none' }} />}
    </div>
  </div>
);

export default DowntimeTab;
